import React from 'react'

import classNames from 'classnames'

import { SmartTableHeadCellProps, SortDir } from './types'
import { useSmartTable } from './useSmartTable'

export const SmartTableHeadCell = (props: SmartTableHeadCellProps) => {
    const tableData = useSmartTable()

    const isCurrent = () => {
        return tableData.currentSortBy === props.sort
    }

    const sortLinkClassNames = () => {
        const classes = ['sort', 'fndt_sort_link']
        if (isCurrent()) {
            classes.push('ed')
        }

        return classes.join(' ')
    }

    const sortIcon = () => {
        return isCurrent()
            ? tableData.currentSortDir === SortDir.Asc
                ? 'bi-arrow-up'
                : 'bi-arrow-down'
            : 'bi-arrow-down-up'
    }

    const handleSort = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault()

        if (props.sort) {
            if (!isCurrent()) {
                tableData.onSort(props.sort, SortDir.Desc)
            } else {
                tableData.onSort(props.sort, oppositeSort())
            }
        }
    }

    const oppositeSort = () => {
        return tableData.currentSortDir === SortDir.Asc
            ? SortDir.Desc
            : SortDir.Asc
    }

    const renderUnsortable = () => {
        return <th className={props.className}>{props.children}</th>
    }

    const renderSortable = () => {
        return (
            <th className={props.className}>
                <a
                    href="#"
                    data-sort={props.sort}
                    data-sort-dir={isCurrent() ? props.sortDir : 'none'}
                    className={sortLinkClassNames()}
                    onClick={handleSort}>
                    {props.children}
                    <span> </span>
                    <i className={classNames('bi', sortIcon())}></i>
                </a>
            </th>
        )
    }
    return props.sort ? renderSortable() : renderUnsortable()
}
